import { render, staticRenderFns } from "./community_management.vue?vue&type=template&id=d62eafe4"
import script from "./community_management.vue?vue&type=script&lang=js"
export * from "./community_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports